import React from 'react'
import Skeleton from 'react-loading-skeleton'

const CategorySkeleton = () => {
  const topCategoriesCount = 6

  return (
    <div className="md:mt-[121px] -mt-6 hidden md:block">
      <div className="container md:mt-[60px] flex items-center gap-2 min-[1248px]:gap-3 min-[1400px]:gap-4">
        <div className="relative">
          <div className="bg-gray-200 py-2 px-4 min-[1400]:py-3 min-[1400]:px-5 rounded-xl flex items-center gap-3">
            <Skeleton width={20} height={20} />
            <Skeleton width={120} height={16} />
          </div>
        </div>

        <nav className="flex items-center justify-between py-3 flex-1 gap-1">
          {Array(topCategoriesCount)
            .fill()
            .map((_, index) => (
              <div
                key={index}
                className="flex items-center gap-2 py-2 px-2 rounded-xl shrink-0 md:py-2 md:px-3"
              >
                <Skeleton width={16} height={16} />
                <Skeleton width={80 + index * 10} height={15} />
              </div>
            ))}
        </nav>
      </div>
    </div>
  )
}

export default CategorySkeleton
